function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import classNames from 'classnames';
import gettext from 'js-utils/gettext';
import { NOTIFICATION_OPTIONS_PROP_TYPES } from '../notification/constants';
import { SIZES as BUTTON_SIZES } from '../button/constants';
import { ICON_PROP_TYPE } from '../iconButton/constants';
import IconButton from '../iconButton/IconButton';
import _ from 'lodash';
import FocusTrap from 'focus-trap-react';
import onClickOutsideHOC from '../utils/onClickOutsideDecorator';
import { addWindowListener, removeWindowListener, HAS_DOCUMENT } from '../utils/dom';
import * as constants from './constants';
import CollapsiblePaneLayout from './CollapsiblePaneLayout';
import ModalBody from './ModalBody';
import CrossChunkySvg from '../iconography/icons/CrossChunky';

var CloseButton = function CloseButton(_ref) {
  var onClose = _ref.onClose;
  var component = null;

  if (onClose) {
    component = React.createElement("div", {
      className: "eds-modal__close-button"
    }, React.createElement(IconButton, {
      "data-automation": "modal-close-button",
      "data-spec": "close-button",
      onClick: onClose,
      iconType: React.createElement(CrossChunkySvg, null),
      title: gettext('Close'),
      isOverImage: true
    }));
  }

  return component;
};

var DecoratedModalBody = onClickOutsideHOC(function (_ref2) {
  var children = _ref2.children,
      onClose = _ref2.onClose,
      headerActionIconType = _ref2.headerActionIconType,
      headerActionTitle = _ref2.headerActionTitle,
      onHeaderAction = _ref2.onHeaderAction,
      title = _ref2.title,
      secondaryTitle = _ref2.secondaryTitle,
      illustration = _ref2.illustration,
      pane = _ref2.pane,
      isPaneOpen = _ref2.isPaneOpen,
      primarySize = _ref2.primarySize,
      primaryType = _ref2.primaryType,
      primaryText = _ref2.primaryText,
      primaryIsDisabled = _ref2.primaryIsDisabled,
      onPrimaryAction = _ref2.onPrimaryAction,
      secondaryType = _ref2.secondaryType,
      secondaryText = _ref2.secondaryText,
      secondaryIsDisabled = _ref2.secondaryIsDisabled,
      onSecondaryAction = _ref2.onSecondaryAction,
      tertiaryNode = _ref2.tertiaryNode,
      onTertiaryAction = _ref2.onTertiaryAction,
      dangerouslySetContainerClassName = _ref2.dangerouslySetContainerClassName,
      modalBodyIsEmpty = _ref2.modalBodyIsEmpty,
      notificationOptions = _ref2.notificationOptions,
      buttonBarMessage = _ref2.buttonBarMessage;
  var dangerousClassName;

  if (dangerouslySetContainerClassName) {
    dangerousClassName = dangerouslySetContainerClassName.__className;
  }

  var className = classNames('eds-modal__body', 'eds-fx--grow', dangerousClassName);
  var modalBody = React.createElement(CollapsiblePaneLayout, {
    isPaneOpen: isPaneOpen,
    pane: pane,
    content: React.createElement(ModalBody, {
      headerActionIconType: headerActionIconType,
      headerActionTitle: headerActionTitle,
      onHeaderAction: onHeaderAction,
      title: title,
      secondaryTitle: secondaryTitle,
      illustration: illustration,
      primarySize: primarySize,
      primaryType: primaryType,
      primaryText: primaryText,
      primaryIsDisabled: primaryIsDisabled,
      onPrimaryAction: onPrimaryAction,
      secondaryType: secondaryType,
      secondaryText: secondaryText,
      secondaryIsDisabled: secondaryIsDisabled,
      onSecondaryAction: onSecondaryAction,
      tertiaryNode: tertiaryNode,
      onTertiaryAction: onTertiaryAction,
      notificationOptions: notificationOptions,
      buttonBarMessage: buttonBarMessage
    }, children)
  });

  if (modalBodyIsEmpty) {
    modalBody = children;
  }

  return React.createElement("dialog", {
    className: className,
    "aria-hidden": "false",
    "data-spec": "eds-modal-body"
  }, modalBody, React.createElement(CloseButton, {
    onClose: onClose
  }));
});

var Modal =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Modal, _React$PureComponent);

  function Modal() {
    _classCallCheck(this, Modal);

    return _possibleConstructorReturn(this, _getPrototypeOf(Modal).apply(this, arguments));
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var isShown = this.props.isShown;
      this._boundHandleEscKey = this._handleEscKey.bind(this);

      this._checkShownState(isShown);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref3) {
      var isShown = _ref3.isShown;

      this._checkShownState(isShown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._unattachWindowListeners();

      this._lockModalViewport(false);
    } // used to lock the viewport so that the user can scroll under the modal

  }, {
    key: "_lockModalViewport",
    value: function _lockModalViewport(isLocked) {
      if (HAS_DOCUMENT) {
        var lockClass = 'eds-modal--hidden-overflow';

        if (isLocked) {
          document.body.classList.add(lockClass);
        } else {
          document.body.classList.remove(lockClass);
        }
      }
    }
  }, {
    key: "_checkShownState",
    value: function _checkShownState(isShown) {
      this._lockModalViewport(isShown);

      if (isShown) {
        this._attachWindowListeners();
      } else {
        this._unattachWindowListeners();
      }
    }
  }, {
    key: "_attachWindowListeners",
    value: function _attachWindowListeners() {
      addWindowListener('keydown', this._boundHandleEscKey);
    }
  }, {
    key: "_unattachWindowListeners",
    value: function _unattachWindowListeners() {
      removeWindowListener('keydown', this._boundHandleEscKey);
    }
  }, {
    key: "_handleClose",
    value: function _handleClose() {
      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }, {
    key: "_handleEscKey",
    value: function _handleEscKey(event) {
      if (event.key === 'Escape') {
        this._handleClose();
      }
    }
  }, {
    key: "_handleClickOutside",
    value: function _handleClickOutside() {
      var disableCloseOnClickOutside = this.props.disableCloseOnClickOutside;

      if (!disableCloseOnClickOutside) {
        this._handleClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          children = _this$props.children,
          type = _this$props.type,
          isShown = _this$props.isShown,
          noMinHeight = _this$props.noMinHeight,
          title = _this$props.title,
          secondaryTitle = _this$props.secondaryTitle,
          illustration = _this$props.illustration,
          pane = _this$props.pane,
          isPaneOpen = _this$props.isPaneOpen,
          headerActionIconType = _this$props.headerActionIconType,
          headerActionTitle = _this$props.headerActionTitle,
          onHeaderAction = _this$props.onHeaderAction,
          primarySize = _this$props.primarySize,
          primaryType = _this$props.primaryType,
          primaryText = _this$props.primaryText,
          primaryIsDisabled = _this$props.primaryIsDisabled,
          onPrimaryAction = _this$props.onPrimaryAction,
          secondaryType = _this$props.secondaryType,
          secondaryText = _this$props.secondaryText,
          secondaryIsDisabled = _this$props.secondaryIsDisabled,
          onSecondaryAction = _this$props.onSecondaryAction,
          tertiaryNode = _this$props.tertiaryNode,
          onTertiaryAction = _this$props.onTertiaryAction,
          onClose = _this$props.onClose,
          noPadding = _this$props.noPadding,
          dangerouslySetContainerClassName = _this$props.dangerouslySetContainerClassName,
          modalBodyIsEmpty = _this$props.modalBodyIsEmpty,
          notificationOptions = _this$props.notificationOptions,
          roleIsDialog = _this$props.roleIsDialog,
          buttonBarMessage = _this$props.buttonBarMessage;

      if (!isShown) {
        return null;
      }

      var modalClasses = classNames('eds-modal', 'eds-fx--fade-in', (_classNames = {}, _defineProperty(_classNames, "eds-modal--".concat(type), type), _defineProperty(_classNames, 'eds-modal--active', isShown), _defineProperty(_classNames, 'eds-modal--has-padding', !noPadding), _defineProperty(_classNames, 'eds-modal--set-height', !noMinHeight), _classNames)); // We need to set a fallbackFocus in case there was no inital foucsed element
      // https://github.com/davidtheclark/focus-trap/blob/master/index.js#L156

      var focusTrapOptions = {
        fallbackFocus: function fallbackFocus() {
          return _.noop;
        }
      };
      var accessibilityProps = {
        role: 'alertdialog'
      }; // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute

      if (title) {
        accessibilityProps = _objectSpread({}, accessibilityProps, {
          'aria-labelledby': constants.MODAL_TITLE_ID
        });
      } // Default to alertdialog role type unless specifically dialog type is requested
      // https://www.w3.org/TR/wai-aria-1.1/#alertdialog & https://www.w3.org/TR/wai-aria-1.1/#dialog


      if (roleIsDialog) {
        accessibilityProps = _objectSpread({}, accessibilityProps, {
          'role': 'dialog'
        });
      }

      return React.createElement(FocusTrap, {
        focusTrapOptions: focusTrapOptions
      }, React.createElement("div", _extends({
        className: modalClasses,
        "data-spec": "eds-modal"
      }, accessibilityProps), React.createElement(DecoratedModalBody, {
        onClose: onClose,
        primarySize: primarySize,
        primaryType: primaryType,
        primaryText: primaryText,
        primaryIsDisabled: primaryIsDisabled,
        onPrimaryAction: onPrimaryAction,
        secondaryType: secondaryType,
        secondaryText: secondaryText,
        secondaryIsDisabled: secondaryIsDisabled,
        tertiaryNode: tertiaryNode,
        onTertiaryAction: onTertiaryAction,
        onSecondaryAction: onSecondaryAction,
        headerActionIconType: headerActionIconType,
        headerActionTitle: headerActionTitle,
        onHeaderAction: onHeaderAction,
        title: title,
        secondaryTitle: secondaryTitle,
        illustration: illustration,
        pane: pane,
        isPaneOpen: isPaneOpen,
        onClickOutside: this._handleClickOutside.bind(this),
        dangerouslySetContainerClassName: dangerouslySetContainerClassName,
        modalBodyIsEmpty: modalBodyIsEmpty,
        notificationOptions: notificationOptions,
        buttonBarMessage: buttonBarMessage
      }, children)));
    }
  }]);

  return Modal;
}(React.PureComponent);

_defineProperty(Modal, "propTypes", {
  /**
   * The contents to display in the model
  */
  children: constants.MODAL_CHILDREN_PROPTYPE.isRequired,

  /**
   * The type of modal that should be shown
  */
  type: PropTypes.oneOf(constants.TYPES),

  /**
  * A function with the desired behavior on mount (componentDidMount)
  */
  onMount: PropTypes.func,

  /**
   * Is the dialog currently shown?
  */
  isShown: PropTypes.bool,

  /**
   * Removes min height for simple Modals
  */
  noMinHeight: PropTypes.bool,

  /**
   * Is the dialog closable?
  */
  isClosable: PropTypes.bool,

  /**
   * Removes padding on the modal container
  */
  noPadding: PropTypes.bool,

  /**
   * Add a class to the modals wrapper <dialog>
  */
  dangerouslySetContainerClassName: PropTypes.shape({
    __className: PropTypes.string
  }),

  /**
  * A function with the desired behavior on close
  */
  onClose: PropTypes.func,

  /**
   * The icon to use for the secondary header action
   */
  headerActionIconType: ICON_PROP_TYPE,

  /**
   * The title for the secondary header action icon
  */
  headerActionTitle: EBPropTypes.translation,

  /**
  * A function with the desired behavior on clicking the secondary header action icon
  */
  onHeaderAction: PropTypes.func,

  /**
   * The title displayed above the content
  */
  title: constants.MODAL_TITLE_PROPTYPE,

  /**
   * The title displayed above the content
  */
  secondaryTitle: PropTypes.node,

  /**
   * The illustration displayed inside the modal
  */
  illustration: PropTypes.node,

  /**
   * The type of button that should be shown for primary button
  */
  primaryType: PropTypes.string,

  /**
   * The text that should be shown across the primary button
  */
  primaryText: PropTypes.node,

  /**
   * The size of the primary button
  */
  primarySize: PropTypes.oneOf(_toConsumableArray(BUTTON_SIZES)),

  /**
   * Whether the primary button should be disabled
  */
  primaryIsDisabled: PropTypes.bool,

  /**
   * The function that should be triggered on primary button click
  */
  onPrimaryAction: PropTypes.func,

  /**
   * The type of button that should be shown for secondary button
  */
  secondaryType: PropTypes.string,

  /**
   * The text that should be shown across the secondary button
  */
  secondaryText: PropTypes.node,

  /**
   * Whether the secondary button should be disabled
  */
  secondaryIsDisabled: PropTypes.bool,

  /**
   * The function that should be triggered on secondary button click
  */
  onSecondaryAction: PropTypes.func,

  /**
   * The node that will act as a tertiary action
  */
  tertiaryNode: PropTypes.node,

  /**
   * The function that should be triggered on tertiary node click
  */
  onTertiaryAction: PropTypes.func,

  /**
   * A message to show above the button bar
  */
  buttonBarMessage: PropTypes.string,

  /**
   * True if the modal body should be empty, i.e. not include the header, footer, or body containers
  */
  modalBodyIsEmpty: PropTypes.bool,

  /**
   * Disables the ability to close the modal by clicking the outside overlay
  */
  disableCloseOnClickOutside: PropTypes.bool,

  /**
   * Used to render notifications inside the modal header.
  */
  notificationOptions: PropTypes.oneOfType([NOTIFICATION_OPTIONS_PROP_TYPES, PropTypes.arrayOf(NOTIFICATION_OPTIONS_PROP_TYPES)]),

  /**
   * Changes the role attribute to dialog
   */
  roleIsDialog: PropTypes.bool,

  /**
   * The content to display next to the pane
  */
  content: PropTypes.node,

  /**
   * The content to display inside the pane, if any
  */
  pane: PropTypes.node,

  /**
   * Whether pane is open or closed
  */
  isPaneOpen: PropTypes.bool
});

_defineProperty(Modal, "defaultProps", {
  type: constants.TYPE_SIMPLE,
  isShown: false,
  noPadding: false,
  roleIsDialog: false
});

export { Modal as default };